import React from "react";
import { Bell } from "lucide-react";
import "./VendorNotifications.css";

// No notifications table exists yet. This renders the empty state now and
// is shaped to drop real data straight in later — swap the mock `notifications`
// array below for a supabase fetch (e.g. a `vendor_notifications` table keyed
// on vendor_id) once that's built, and this page needs no other changes.
const notifications = [];

const VendorNotifications = () => {
  return (
    <div className="vnt-page">
      <div className="vnt-header">
        <h1 className="vnt-title">Notifications</h1>
        <p className="vnt-subtitle">Updates on your applications, documents, and payments.</p>
      </div>

      {notifications.length === 0 ? (
        <div className="vnt-empty">
          <Bell size={20} />
          <p>You're all caught up — nothing new right now.</p>
        </div>
      ) : (
        <div className="vnt-list">
          {notifications.map((n) => (
            <div key={n.id} className="vnt-row">
              <span className="vnt-row-text">{n.message}</span>
              <span className="vnt-row-time">{n.created_at}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorNotifications;